import { useState, type FormEvent } from 'react';
import { apiService } from '../../services/api';

export type SubscribeStatus = 'idle' | 'loading' | 'ok' | 'error';

/** Inscription à la newsletter via l'API, partagée par le footer et la colonne des articles. */
export function useSubscribe() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<SubscribeStatus>('idle');

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await apiService.subscribeNewsletter(email);
      setStatus('ok');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return { email, setEmail, status, submit };
}
